import React, { Component } from 'react';
import '../css/app.css';
import Header from '../component/header';
import Footer from '../component/footer';
import FaqSection from '../component/faqSection';

class Faq extends Component {
  constructor(props) {
    super(props)
    console.log('Faq')
    console.log(props)
  }

  componentDidMount() {
    if (this.props.match !== undefined && this.props.match.params !== undefined) {
      if (this.props.match.params.id !== undefined && this.props.match.params.id !== "") {
        const element = document.getElementById(this.props.match.params.id);
        if (element) {
          console.log("scrollIntoView")
          setTimeout(() => {
            element.scrollIntoView({ block: 'end',  behavior: 'smooth' });
          }, 100)
          
        }
      }
    }
  }

  render() {
    return (
      <div className="faq-frame">
        <Header context={(this.props.context !== undefined) ? this.props.context: "" } />
        <FaqSection context={(this.props.context !== undefined) ? this.props.context: "" } />
        <Footer context={(this.props.context !== undefined) ? this.props.context: "" } />
      </div>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/pages/faq.js